<template>
  <select-dict v-model="installedSystemCode" :select-list="systemTypes" />
</template>

<script setup lang="ts">
import { defineModel, watch } from "vue";

import SelectDict from "@/components/UI/SelectDict.vue";
import { useDictStore } from "@/stores/dictStore";
import { useMountsStore } from "@/stores/new/mounts.store";
import { useDoorsStore } from "@/stores/new/doors.store";
import { useOverdoorStore } from "@/stores/new/overdoor.store";

const dictStore = useDictStore();
const mountsStore = useMountsStore();
const doorsStore = useDoorsStore();
const overdoorsStore = useOverdoorStore();

const installedSystemCode = defineModel<string>({ default: "" });
const systemTypes = dictStore.getSystemTypes();

watch(
  () => installedSystemCode.value,
  (currentCode, prevValue) => {
    if (prevValue && prevValue !== currentCode) {
      doorsStore.$reset();
      overdoorsStore.$reset();
      mountsStore.$reset();
    }
  },
  {
    immediate: true,
  },
);
</script>

<style lang="scss" scoped></style>
